var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket-header"},[_c('img',{attrs:{"src":require("../assets/img/line_between_left.png")}}),_c('span',{staticClass:"basket-header__text"},[_vm._t("default")],2),_c('img',{attrs:{"src":require("../assets/img/line_between_right.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }